import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import '../sass/App.scss';
import { checkEnvPurpleZone, getSearchParams, namespace } from './common/Utils';
import { PURPLEZONE_CHARACTER_ID_KEY, PURPLEZONE_SERVER_ID_KEY } from './common/constants';
import { Index as DetailIndex } from './detail/Index';
import { Config } from './interface/ICommon';
import { Index as ItemPrice } from './itemprice/Index';
import { Index as L10n } from './l10n/Index';
import { store } from './store';
import { setConfig, setNow } from './store/mainSlice';

class App {
    constructor(_config: Config) {
        if (checkEnvPurpleZone()) {
            // 퍼플존 팝업의 pzsid, pzcid URL params를 sessionStorage에 설정
            const searchParams = getSearchParams(document.location.href);
            if (searchParams) {
                const purplezoneServerId = searchParams[PURPLEZONE_SERVER_ID_KEY];
                if (purplezoneServerId) {
                    sessionStorage.setItem(PURPLEZONE_SERVER_ID_KEY, purplezoneServerId);
                }

                const purplezoneCharacterId = searchParams[PURPLEZONE_CHARACTER_ID_KEY];
                if (purplezoneCharacterId) {
                    sessionStorage.setItem(PURPLEZONE_CHARACTER_ID_KEY, purplezoneCharacterId);
                }
            }
        }

        store.dispatch(setConfig(_config));
        store.dispatch(setNow('price'));

        const container = document.querySelector('.itemprice-container')!;
        createRoot(container).render(
            <Provider store={store}>
                <L10n>
                    <ItemPrice />
                    <DetailIndex />
                </L10n>
            </Provider>
        );
    }
}
namespace('nc.info');
window.nc.info.itemprice = App;
